import { memo } from 'react';
import { Alert, Card, Text } from '@zillow/constellation-10';
import type { YourRentalErrorDto } from '@zg-rentals/ts-your-rental-api-client';

const PaymentCardError = memo(({ error }: { error: YourRentalErrorDto }) => {
  return (
    <Card
      elevated={false}
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: 'loose',
        gap: 'default',
      }}
    >
      <Text textStyle="body-sm-bold" data-testid="RentReporting-PaymentCardTitle">
        {error.cardTitle}
      </Text>
      <Alert tone="critical" css={{ width: '100%' }}>
        {error.message}
      </Alert>
    </Card>
  );
});

PaymentCardError.displayName = 'PaymentCardError';

export default PaymentCardError;
